<template>
    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.orderNumber') }}</div>
        <div class="font-mono text-right pr-1">{{ order.number }}</div>
    </div>
    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.orderDate') }}</div>
        <div class="font-mono text-right pr-1">{{ order.order_date }}</div>
    </div>
    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.orderReceived') }}</div>
        <div class="font-mono text-right pr-1">{{ order.created_at }}</div>
    </div>

    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full mt-2">
        <div class="">{{ $t('orders.channel') }}</div>
        <div class="flex font-mono items-center pr-1 justify-end whitespace-nowrap">
            <Dot size="3" :color="order.salesOrg.color"></Dot>
            <span class="overflow-ellipsis overflow-hidden">{{ order.salesOrg.name }}</span>
        </div>
    </div>

    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.extOrderNumber') }}</div>
        <div class="font-mono text-right pr-1">{{ order.channel_no }}</div>
    </div>

    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.extId') }}</div>
        <div class="font-mono text-right pr-1">{{ order.sales_org_reference }}</div>
    </div>

    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.fulfilling') }}</div>
        <div class="font-mono text-right flex flex-col justify-center items-end pr-1">
            <CheckIcon v-if="order.fulfilling" class="h-5 w-5 text-green-400"/>
            <XMarkIcon v-if="!order.fulfilling" class="h-5 w-5 text-gray-400"/>
        </div>
    </div>

    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full mt-2">
        <div class="">{{ $t('orders.totalNet') }}</div>
        <div class="font-mono text-right pr-1">{{ order.netTotal }}</div>
    </div>
    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full">
        <div class="">{{ $t('orders.totalTax') }}</div>
        <div class="font-mono text-right pr-1">{{ order.tax }}</div>
    </div>

    <div class="grid grid-cols-2 grid-flow-col gap-4 w-full mt-2">
        <div class="">{{ $t('orders.totalGross') }}</div>
        <div class="font-mono text-right pr-1 bg-gray-300">{{ order.grossTotal }}</div>
    </div>

</template>

<script>
import {CheckIcon, XMarkIcon} from "@heroicons/vue/24/outline";
import Dot from "@/Shared/Components/Dot";

export default {
    props: ['order'],
    components: {
        CheckIcon,
        XMarkIcon,
        Dot
    }
}
</script>

<style scoped>

</style>
